/**
 * ニュースティッカー
 */
import ResizeWatch from '../utils/ResizeWatch';
import ScrollWatch from '../utils/ScrollWatch';
import AnyStore from '../common/AnyStore';

export default class HomeTicker {
  /**
   * コンストラクタ
   */
  constructor(isForce) {
    // クラス名
    this.name = 'HomeTicker';
    this.isShow = false;
    this.isForce = (AnyStore.setDevice() === 'pc' && isForce === true);
    this.el = document.getElementById('c-ticker');

    if (this.el) {
      this.init();
    }
  }

  /**
   * 表示前
   */
  init() {
    this.newsList = this.el.querySelectorAll('li');
    this.current = 0;
    this.max = this.newsList.length;
  }

  /**
   * 表示
   */
  start() {
    this.resizeUpdate();
    setTimeout(this.showTick.bind(this), 1000);
  }

  scrollable() {
    if ((this.winH * 0.1) < AnyStore.getScrollTop()) {
      this.isShow = false;
    } else {
      this.isShow = true;
    }
    ResizeWatch.registerObserver(this.name, this);
    ScrollWatch.registerObserver(this.name, this);
  }

  showTick() {
    this.show();
  }

  hideTick() {
    this.hide();
  }

  show() {
    const ref = this.newsList[this.current];
    TweenMax.fromTo(ref, 0.7, {
      y: '50%',
      opacity: 0,
      visibility: 'visible'
    }, {
      y: '0%',
      opacity: 1,
      ease: Power3.easeOut,
      onComplete: this.showComp.bind(this)
    });
  }

  showComp() {
    setTimeout(this.hideTick.bind(this), 3000);
  }

  hide() {
    const ref = this.newsList[this.current];
    TweenMax.to(ref, 0.7, {
      y: '-50%',
      opacity: 0,
      onComplete: this.hideComp.bind(this)
    });
  }

  hideComp() {
    const ref = this.newsList[this.current];
    TweenMax.set(ref, {visibility: 'hidden'});

    this.current = (this.current + 1) % this.max;
    this.showTick();
  }

  /**
   * スクロール
   */
  scrollUpdate(_scrollY) {
    if ((this.winH * 0.1) < _scrollY) {
      // 消す
      if (this.isShow) {
        this.isShow = false;
        TweenMax.set(this.el, {className: '+=is-hide'});
      }
    } else {
      // 表示
      if (!this.isShow) {
        this.isShow = true;
        TweenMax.set(this.el, {className: '-=is-hide'});
      }
    }
  }

  /**
   * リサイズ
   */
  resizeUpdate() {
    this.winH = window.innerHeight;
    this.scrollUpdate(AnyStore.getScrollTop());
  }

  check() {
    //console.log('テスト');
    //this.isForce = false;
    //this.resizeUpdate();
    this.isHide = true;
    TweenMax.set(this.el, {className: '+=is-hide'});
  }
}
